import { Add } from "@mui/icons-material";
import { Box, IconButton, Typography } from "@mui/material";
import Breadcrumb from "common/Breadcrumbs";
import React from "react";

const TableHeader = ({ onClick, title, showAddButton, hideBreadcrumb }) => {
  return (
    <Box>
      <Box sx={{ display: "flex", justifyContent: "space-between" }}>
        <Typography variant="h5" mb={2} color="#0a0a0a">
          {title}
        </Typography>
        {showAddButton && (
          <Box>
            <IconButton
              sx={{
                bgcolor: "primary.main",
                color: "white",
                "&:hover": { bgcolor: "primary.light" },
              }}
              variant="contained"
              onClick={onClick}
            >
              <Add />
            </IconButton>
          </Box>
        )}
      </Box>
      {hideBreadcrumb ? null : <Breadcrumb />}
    </Box>
  );
};

export default TableHeader;
